import { Validation } from '~helpers/forms/Validation';
import { UseFormField, UseFormFieldValidate } from '~hooks/useForm';

import { BlogConfig } from '../../../config.types';

const REQUIRED_MSG = 'Обязательное поле';

export type FieldKey =
  | 'name'
  | 'email'
  | 'phone'
  | 'company'
  | 'comment'
  | 'privacy'
  | 'information';
type ConfigurableFieldKey = Exclude<FieldKey, 'privacy' | 'information'>;

const defaultRequired: Partial<Record<FieldKey, boolean>> = {
  email: true,
  phone: true,
  privacy: true,
};

export function getRequiredMark(
  fosBatut: BlogConfig['fosBatut'],
  field: FieldKey,
): string {
  const fromConfig =
    fosBatut?.fields?.[field as ConfigurableFieldKey]?.required;
  const required = fromConfig ?? defaultRequired[field] ?? false;
  return required ? '*' : '';
}

const defaultFields: Record<string, UseFormField> = {
  name: {
    value: '',
    validate: Validation.name('В имени не должно быть цифр'),
  },
  email: {
    value: '',
    validate: Validation.required(
      Validation.email('Некорректно указан Email'),
      REQUIRED_MSG,
    ),
  },
  phone: {
    value: '',
    validate: Validation.required(
      Validation.phone('Некорректно указан телефон'),
      REQUIRED_MSG,
    ),
  },
  company: { value: '' },
  comment: { value: '' },
  privacy: {
    value: true,
    validate: Validation.required(
      Validation.privacy(
        'Необходимо принять условия пользовательского соглашения',
      ),
      REQUIRED_MSG,
    ),
  },
};

const makeValidate: Record<
  ConfigurableFieldKey,
  (required: boolean) => UseFormFieldValidate | undefined
> = {
  name: (required: boolean) =>
    required
      ? Validation.required(
          Validation.name('В имени не должно быть цифр'),
          REQUIRED_MSG,
        )
      : Validation.name('В имени не должно быть цифр'),

  email: (required: boolean) =>
    required
      ? Validation.required(
          Validation.email('Некорректно указан Email'),
          REQUIRED_MSG,
        )
      : Validation.email('Некорректно указан Email'),

  phone: (required: boolean) =>
    required
      ? Validation.required(
          Validation.phone('Некорректно указан телефон'),
          REQUIRED_MSG,
        )
      : Validation.phone('Некорректно указан телефон'),

  company: (required: boolean) =>
    required ? Validation.required(undefined, REQUIRED_MSG) : undefined,

  comment: (required: boolean) =>
    required ? Validation.required(undefined, REQUIRED_MSG) : undefined,
};

export function buildFormFields(
  fosBatut?: BlogConfig['fosBatut'],
): Record<string, UseFormField> {
  // Нет конфига — дефолт без изменений
  if (!fosBatut?.fields) return defaultFields;

  const result = { ...defaultFields };

  for (const key of Object.keys(fosBatut.fields) as ConfigurableFieldKey[]) {
    const conf = fosBatut.fields[key];
    if (conf?.required === undefined) continue;

    result[key] = {
      ...result[key],
      validate: makeValidate[key]?.(conf.required),
    };

    if (fosBatut.fields.information) {
      result.information = { value: false };
    }
  }

  return result;
}
